module.exports = __webpack_public_path__ + "static/media/Programarea Neuro-Lingvistică.1c40bd36.png";